import React from 'react'
import { ImageSourcePropType } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { Image } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/image/Image'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { BodyTextSize, TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'

import { SchedulingLandingInfo } from '../constants'

const DescriptionContainer = styled.View(() => ({
  maxWidth: '240px',
}))

const InformationContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  display: 'flex',
  width: 'auto',
  paddingTop: theme.spacing['16px'],
  paddingBottom: theme.spacing['48px'],
  flexDirection: 'row',
  justifyContent: 'space-between',
}))

const InfoItem = styled.View(() => ({
  maxWidth: '253px',
}))

const TitleContainer = styled.View(({ theme }) => ({
  marginBottom: theme.spacing['8px'],
  marginTop: theme.spacing['16px'],
}))

export const SchedulingInformation: React.FC = () => {
  const { colors } = useTheme()

  const generateSchedulingInfo = (
    informationElement: {
      image: ImageSourcePropType
      title: string
      description: string
    },
    index: number,
  ) => {
    return (
      <InfoItem key={index}>
        <Image
          source={informationElement.image}
          style={{
            width: 64,
            height: 64,
          }}
        />
        <TitleContainer>
          <Title level='4' color={colors.textSecondary} size={TitleSize.XSMALL} text={informationElement.title} />
        </TitleContainer>
        <DescriptionContainer>
          <BodyText color={colors.textSecondary} size={BodyTextSize.SMALL} text={informationElement.description} />
        </DescriptionContainer>
      </InfoItem>
    )
  }

  const renderSchedulingInfoList = () => {
    const schedulingInfoList = SchedulingLandingInfo.map((informationElement, index) =>
      generateSchedulingInfo(informationElement, index),
    )
    return <InformationContainer>{schedulingInfoList}</InformationContainer>
  }

  return renderSchedulingInfoList()
}
